import {
  Button, Select, Layout, theme, Input, Form, notification
} from "antd";
import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import UserApi from "../../common/Apis/UserApi";
import { Row, Col } from "antd";
import Sidebar from "../../common/Sidebar/Sidebar";
import TopHeader from "../../common/TopHeader/TopHeader";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import RoleApi from "../../common/Apis/RoleApi";

const { Content } = Layout;
const AddUserTenant = () => {
  let navigate = useNavigate();
  const [UserEmails, setUserEmails] = useState();
  const {
    token: { colorBgContainer },
  } = theme.useToken();


  const [ListRoles, setListRoles] = useState([]);
  const getRoles = useCallback(() => {
    RoleApi.ListAllRoles()
      .then((response) => {
        setListRoles(response.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getRoles();
  }, [getRoles]);
  const handleChange = (value) => {
    setUserEmails(value);
    console.log(value);
  };
  const [inputPassword, setInputPassword] = React.useState("");
  const [inputValuestart, setinputValuestart] = React.useState(true);

  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [passwordVisible, setPasswordVisible] = React.useState(false);
  const [ConfirmPasswordVisible, setConfirmPasswordVisible] =
    React.useState(false);
  const handleChangePassword = (event) => {
    setInputPassword(event.target.value);

    setinputValuestart(false);
  };

  const handleSubmit = (data) => {
    if (decodedToken.tenantId) {
      let formData = JSON.stringify({
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        password: inputPassword,
        matchingPassword: data.matchingPassword,
        roleDTOs: [
          {
            id: data.roleName,
          },
        ],
        tenantDTO: {
          id: decodedToken.tenantId,
        },
      });
      if (data.matchingPassword === inputPassword) {
        // register Api
        UserApi.AddNewUser(formData)
          .then((response) => {
            console.log(response);
            notification.open({
              message: (
                <span style={{ fontWeight: "bold" }}>Aptitude Test Sent</span>
              ),
              description: "Please check your inbox",
              closeIcon: false,
              duration: 3,
              style: {
                backgroundColor: "#b3ffb3",
                color: "green",
              },
            });
            return navigate("/users");
          })
          .catch((err) => {
            // Error Notification
            notification.open({
              message: (
                <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
              ),
              description: err.apiError.message,
              closeIcon: false,
              duration: 3,
              style: {
                backgroundColor: "#fff2f0",
                color: "red",
              },
            });
          });
      } else {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Error</span>,
          description: "Password Not Match!",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#ffb3b3",
            color: "red",
          },
        });
      }

    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="firstName"
                    label="First Name"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter First Name.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="First Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="lastName"
                    label="last Name"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter last Name.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="last Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="email"
                    label="Email"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Email.",
                      },
                    ]}
                  >
                    <Input
                      type="email"
                      placeholder="Email"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="password"
                    label="Password"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Password.",
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder="Choose a Password"
                      className="control-input mb-2"
                      onChange={handleChangePassword}
                      type="password"
                      visibilityToggle={{
                        visible: passwordVisible,
                        onVisibleChange: setPasswordVisible,
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="matchingPassword"
                    label="Confirm Password"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Confirm Password.",
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder="Confirm Password"
                      className="control-input"
                      visibilityToggle={{
                        visible: ConfirmPasswordVisible,
                        onVisibleChange: setConfirmPasswordVisible,
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="roleName"
                    label="Role Name*"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Select Role name.",
                      },
                    ]}
                  >
                    {ListRoles && (
                      <Select
                        className="control-Select"
                        placeholder="Select Role name"
                        options={ListRoles.filter(item => item.id !== 1).map((item) => ({
                          value: item?.id,
                          label: item?.name,
                        }))}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Send
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default AddUserTenant;
